import { render, staticRenderFns } from "./sold-price.vue?vue&type=template&id=0b54f6c6&scoped=true&"
import script from "./sold-price.vue?vue&type=script&lang=js&"
export * from "./sold-price.vue?vue&type=script&lang=js&"
import style0 from "./sold-price.vue?vue&type=style&index=0&id=0b54f6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54f6c6",
  null
  
)

export default component.exports